import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Badge,
  UncontrolledTooltip,
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  Input,
  FormFeedback,
  Label,
} from "reactstrap"
import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import { withRouter, Link, useLocation } from "react-router-dom"
import { getDateString, getOrderPrefix } from "helpers/common_helper"
import { Type } from "react-bootstrap-table2-editor"
import { WindowScrollController } from "@fullcalendar/core"

const columns = (
  toggle,
  handleValidDate,
  handleOrderClick,
  onClickDelete,
  toLowerCase1,
  toggleViewModal,
  handleConfirm,
  designers,
  path
) => {
  const columns = [
    {
      dataField: "Sno",
      text: "S#",
      sort: true,
      // Product Name column can't be edit anymore
      editable: false,
      formatter: (cell, row, rowIndex, formatExtraData) => {
        return rowIndex + 1
      },
    },
    {
      dataField: "orderCode",
      text: "quote#",
      sort: true,
      // Product Name column can't be edit anymore
      editable: false,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, row) => (
        <Link to="#" className="text-body fw-bold">
          {getOrderPrefix(row.requestFor) + row.orderCode}
        </Link>
      ),
    },
    {
      dataField: "orderStatus",
      text: "quote Status",
      sort: true,
      editor: {
        type: Type.SELECT,
        options: [
          {
            value: "New",
            label: "New",
          },
          {
            value: "Processing",
            label: "Processing",
          },
          {
            value: "Ready",
            label: "Ready",
          },
          {
            value: "Done",
            label: "Done",
          },
        ],
      },
      // eslint-disable-next-line react/display-name
      // formatter: (cellContent, row) => handleValidDate(row.orderdate),
    },
    {
      dataField: "oStatus",
      text: "quote Status",
      sort: true,
      editor: {
        type: Type.SELECT,
        options: [
          {
            value: "New",
            label: "New",
          },
          {
            value: "Edit",
            label: "Edit",
          },
          {
            value: "Revision",
            label: "Revision",
          },
          {
            value: "Jacket Back",
            label: "JacketBack",
          },
          {
            value: "Lost",
            label: "Lost",
          },
        ],
      },
      // eslint-disable-next-line react/display-name
      // formatter: (cellContent, row) => handleValidDate(row.orderdate),
    },
    {
      dataField: "assTo",
      text: "Ass To",
      sort: true,
      editor: {
        type: Type.SELECT,
        getOptions: setOptions => {
          let rec = []
          designers.docs.map(t => {
            rec.push({
              value: t.userName,
              label: t.userName,
            })
          })
          return rec
        },
      },
    },
    {
      dataField: "assToSalesMan",
      text: "Ass To Sales",
      sort: true,
      editor: {
        type: Type.SELECT,
        getOptions: setOptions => {
          let rec = []
          designers.docs.map(t => {
            rec.push({
              value: t.userName,
              label: t.userName,
            })
          })
          return rec
        },
      },
    },
    {
      dataField: "submitDateTime",
      text: "Received Date",
      sort: true,
      // Product Name column can't be edit anymore
      editable: false,
      formatter: (cellContent, row) => getDateString(row.submitDateTime),
    },
    {
      dataField: "sentDate",
      text: "Sent Date",
      sort: true,
      // Product Name column can't be edit anymore
      editable: false,
      formatter: (cellContent, row) => getDateString(row.submitDateTime),
    },
    {
      dataField: "userName",
      text: "Customer",
      sort: true,
      // Product Name column can't be edit anymore
      editable: false,
    },
    {
      dataField: "stiches",
      text: "Stiches",
      sort: true,
      // Product Name column can't be edit anymore
      editable: false,
    },
    {
      dataField: "price",
      text: "price",
      sort: true,
      // Product Name column can't be edit anymore
      editable: false,
    },

    {
      dataField: "orderName",
      text: "quote Name",
      sort: true,
      // Product Name column can't be edit anymore
      editable: false,
      editor: {
        type: Type.TEXT,
      },
    },
    {
      dataField: "process",
      text: "Process",
      isDummyField: true,
      sort: false,
      editable: false,
      formatter: (cellContent, order) => (
        <>
          <button
            type="button"
            onClick={toggleViewModal}
            className="btn-sm btn-rounded mb-2 me-2 btn btn-success"
          >
            <i className="mdi mdi-plus me-1"></i> Process
          </button>
        </>
      ),
    },
    {
      dataField: "convertToOrder",
      text: "Convert To Order",
      isDummyField: true,
      sort: false,
      editable: false,
      formatter: (cellContent, order) => (
        <>
          <button
            type="button"
            onClick={handleConfirm}
            className="btn-sm btn-rounded mb-2 me-2 btn btn-primary"
          >
            <i className="mdi mdi-plus me-1"></i> Convert To Order
          </button>
        </>
      ),
    },
    {
      dataField: "action",
      isDummyField: true,
      text: "Del",
      // Product Name column can't be edit anymore
      editable: false,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, order) => (
        <>
          <div className="d-flex gap-3">
            <Link
              to="#"
              className="text-danger"
              onClick={() => onClickDelete(order)}
            >
              <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
              <UncontrolledTooltip delay={{ show: 0, hide: 0 }} placement="top" target="deletetooltip">
                Delete
              </UncontrolledTooltip>
            </Link>
          </div>
        </>
      ),
    },
  ]

  let filterdColumns = []

// helper function to reorder columns
const reorderColumns = (columns, order) => {
  const map = new Map(columns.map(c => [c.dataField, c]))
  return order.map(key => map.get(key)).filter(Boolean)
}

switch (location.pathname.split("/")[2]) {
  case "convert-to-order":
    filterdColumns = reorderColumns(columns, [
      "Sno",
      "orderCode",
      "orderStatus",
      "submitDateTime",
      "sentDate",
      "userName",
      "orderName",
      "assTo",
      "convertToOrder",
      "process",
      "action"
    ])
    break

  case "todays-vectors":
  case "todays-orders":
  case "todays-quote":
    filterdColumns = reorderColumns(columns, [
      "Sno",
      "orderCode",
      "assTo",
      "submitDateTime",
      "userName",
      "orderName",
      // "orderStatus",
      "process",
      "action"
    ])
    break

  case "ready-orders":
  case "ready-vectors":
  case "ready-quotes":
    filterdColumns = reorderColumns(columns, [
      "Sno",
      "orderCode",
      "submitDateTime",
      "sentDate",
      "userName",
      "orderName",
      "orderStatus",
      "assTo",
      "process",
      "action"
    ])
    break

  case "all-orders":
  case "all-vectors":
  case "all-quotes":
    filterdColumns = reorderColumns(columns, [
      "Sno",
      "oStatus",
      "orderCode",
      "submitDateTime",
      "sentDate",
      "userName",
      "orderName",
      "orderStatus",
      "assTo",
      "assToSalesMan",
      "action"
    ])
    break

  case "vector-with-price-zero":
  case "orders-with-price-zero":
    filterdColumns = reorderColumns(columns, [
      "Sno",
      "orderCode",
      "submitDateTime",
      "sentDate",
      "userName",
      "orderName",
      "orderStatus",
      "stiches",
      "price"
    ])
    break

  case "orders-with-price":
  case "vector-with-price":
    filterdColumns = reorderColumns(columns, [
      "Sno",
      "orderCode",
      "submitDateTime",
      "sentDate",
      "userName",
      "orderName",
      "orderStatus",
      "price",
      "process"
    ])
    break

  default:
    filterdColumns = reorderColumns(columns, [
      "Sno",
      "orderCode",
      "oStatus",
      "assTo",
      "submitDateTime",
      "userName",
      "orderName",
      "process",
      "action"
    ])
    break
}
  return filterdColumns
}

columns.propTypes = {
  toggle: PropTypes.func,
  designers: PropTypes.object,
  handleValidDate: PropTypes.func,
  handleOrderClick: PropTypes.func,
  onClickDelete: PropTypes.func,
  locationPath: PropTypes.string,
  handleConfirm: PropTypes.func,  
}

export default columns
